export default __webpack_public_path__ + "static/media/InteriorThree.c2a07f5d.jpg";